<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12" lg="12">
        <v-card class="mb-7">
          <v-card-text class="pa-5">
            <div class="d-sm-flex align-center">
              <div>
                <h2 class="font-weight-regular title">Información de cotización</h2>
                <h6 class="body-2 mb-1 subtitle-2 font-weight-light">Datos de cotización</h6>
              </div>
            </div>
          </v-card-text>
          <v-card-text class="pa-5 border-bottom">
            <TheCotizacionForm
                v-if="cotizacion"
                :cotizacion="cotizacion"
            ></TheCotizacionForm>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TheCotizacionForm from "@/components/dashboardComponents/TheCotizacionForm"

export default {
  name: "Cotización",
  components: {
    TheCotizacionForm
  },
  data: () => ({
    page: {
      title: "Cotización"
    },
    breadcrumbs: [
      {
        text: "Home",
        disabled: false,
        href: "/dashboard/index/"
      },
      {
        text: "Cotizaciones",
        disabled: true,
        href: "/dashboard/cotizaciones/"
      }
    ],
    cotizacion: null
  }),
  methods: {
    async fetchCotizacion() {
      const cotizacionId = this.$route.params.id
      const res = await this.$http.get(`api/admin/matriculas/cotizaciones/${cotizacionId}/`)
      this.cotizacion = { ...res.data }
    }
  },
  async mounted() {
    await this.fetchCotizacion()
    this.breadcrumbs.push({
      text: `${this.cotizacion.nombres} ${this.cotizacion.apellidos}`,
      disabled: true
    })
  }
}
</script>

<style lang="scss">
.close-button:hover {
  opacity: 0.8%;
}

.upload-button {
  cursor: pointer;
  height: 50px;
  width: 250px;
  border: 1px solid rgba(0, 0, 0, 0.87);
  border-radius: 10px;
}

.voucher-image {
  width: 100%;
}

.card-vouchers {
  border: 1px solid gray !important;
}
</style>
